<template>
   <div class="page-title-bar image-align" :style="{ background: 'url(' +image+ ')'}">
      <div class="container">
         <h1 class="mb-4"> {{heading}}</h1>
         <p class="white--text font-weight-regular"> {{subHeading}} </p>
      </div>
   </div>
</template>

<script>
// import "../../assets/css/commonstylesheet.css";
export default {
   props:['heading','subHeading','image']
}
</script>